import React, { lazy } from "react";
import { Redirect } from "react-router-dom";
import HomeLayout from "src/layouts/HomeLayout";

export const routes = [
  {
    exact: true,
    path: "/",
    layout: HomeLayout,
    component: lazy(() => import("src/views/pages/Home/index")),
  },
  {
    exact: true,
    path: "/mint",
    layout: HomeLayout,
    component: lazy(() => import("src/views/pages/Mint")),
  },

  {
    exact: true,
    path: "/404",
    component: lazy(() => import("src/views/errors/NotFound")),
  },

  {
    exact: true,
    path: "/wallet",
    layout: HomeLayout,
    component: lazy(() => import("src/views/pages/Home/Qrcode")),
  },
  {
    exact: true,
    path: "/wallet-detail",
    layout: HomeLayout,
    component: lazy(() => import("src/views/pages/Home/WalletDetail")),
  },
  {
    exact: true,
    path: "/stake",
    layout: HomeLayout,
    component: lazy(() => import("src/views/pages/Stake/Stake")),
  },
  {
    exact: true,
    path: "/coin-stake",
    layout: HomeLayout,
    component: lazy(() => import("src/views/pages/Stake/StakeWithCoin")),
  },

  {
    exact: true,
    path: "/about",
    layout: HomeLayout,
    component: lazy(() => import("src/views/pages/About Us/AboutUs")),
  },
  {
    exact: true,
    path: "/policy",
    layout: HomeLayout,
    component: lazy(() => import("src/views/pages/About Us/Policy")),
  },
  {
    exact: true,
    path: "/terms",
    layout: HomeLayout,
    component: lazy(() => import("src/views/pages/About Us/Terms")),
  },
  {
    exact: true,
    path: "/faqs",
    layout: HomeLayout,
    component: lazy(() => import("src/views/pages/About Us/FAQ")),
  },
  {
    exact: true,
    path: "/contact",
    layout: HomeLayout,
    component: lazy(() => import("src/views/pages/About Us/Contact")),
  },
  {
    component: () => <Redirect to="/404" />,
  },
];
